<div class="not-found-wrap mat-body">
    <div class="main">
        <div class="error-template">
            <h1>{{ title }}</h1>
            <div class="error-details">
                <p>{{ errorMessage }}</p>
            </div>
            <div class="error-actions">
                <button type="button" (click)="changeState()" mat-raised-button color="primary">
                    Take Me Home
                </button>                
            </div>
        </div>
    </div>
</div>